/*
 * InstitutionLandingPage Messages
 *
 * This contains all the text for the InstitutionLandingPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.pages.l.InstitutionLandingPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: '{title} | Eskolare',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Página de divulgação de produtos e serviços educacionais!',
  },
  shareMessage: {
    id: `${scope}.shareMessage`,
    defaultMessage: 'Olha que legal o que encontrei!',
  },
  // ./components/StudentSelect.js
  selectStudentTitle: {
    id: `${scope}.selectStudentTitle`,
    defaultMessage: 'Para quem gostaria de comprar?',
  },
  selectStudentInstructions: {
    id: `${scope}.selectStudentInstructions`,
    defaultMessage:
      'Selecione qual aluno gostaria de utilizar para comprar nesta página. Caso você ainda não possua uma matrícula válida para compra, ela será gerada automaticamente',
  },
});
